const adminUrl = '/psychometric-admin';

export default adminUrl;
